import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";

type Props = {
  settingCategories: any[];
  selectedCategory: any;
  onSelection: (selectedCategory: any) => void;
};

export const SettingsCategoryList: React.FC<Props> = props => (
  <ListGroup>
    {props.settingCategories.map(category => {
      const isActive = props.selectedCategory === category;
      return (
        <ListGroupItem
          active={isActive}
          key={category}
          onClick={() => props.onSelection(category)}
          style={{ cursor: "pointer" }}
        >
          {category}
        </ListGroupItem>
      );
    })}
  </ListGroup>
);
